import {
  TooltipProvider,
} from "@/components/ui/tooltip";
import DeleteInvitationDialog from "./DeleteInvitationDialog";
import ResendInvitationDialog from "./ResendInvitationDialog";
import type { User } from "@/generated/types";

interface InvitedUsersTableProps {
  invitedUsers: User[];
  loading: boolean;
  onDelete: (id: string) => void;
  onResend: (user: User) => void;
}

export default function InvitedUsersTable({ invitedUsers, loading, onDelete, onResend }: InvitedUsersTableProps) {
  return (
    <TooltipProvider>
      <div className="mb-16">
        <h2 className="text-lg font-light tracking-tight text-primary-950 dark:text-white mb-4">
          Convites Pendentes
        </h2>
        <div className="bg-white dark:bg-primary-900 border border-primary-200 dark:border-primary-800">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="border-b border-primary-200 dark:border-primary-800">
                  <th className="px-6 py-4 text-left text-xs uppercase tracking-widest text-primary-600 dark:text-primary-400 font-normal">
                    E-mail
                  </th>
                  <th className="px-6 py-4 text-left text-xs uppercase tracking-widest text-primary-600 dark:text-primary-400 font-normal">
                    Função
                  </th>
                  <th className="px-6 py-4 text-left text-xs uppercase tracking-widest text-primary-600 dark:text-primary-400 font-normal">
                    Convidado em
                  </th>
                  <th className="px-6 py-4 text-right text-xs uppercase tracking-widest text-primary-600 dark:text-primary-400 font-normal">
                    Ações
                  </th>
                </tr>
              </thead>
              <tbody>
                {invitedUsers.map((user) => (
                  <tr
                    key={user.id}
                    className="border-b border-primary-100 dark:border-primary-800/50 last:border-0"
                  >
                    <td className="px-6 py-4 text-sm text-primary-900 dark:text-white">
                      {user.email}
                    </td>
                    <td className="px-6 py-4">
                      <span className="inline-flex px-3 py-1 text-xs uppercase tracking-widest border border-primary-200 dark:border-primary-700 text-primary-700 dark:text-primary-300">
                        {user.role}
                      </span>
                    </td>
                    <td className="px-6 py-4 text-sm text-primary-600 dark:text-primary-400">
                      {user.invitedAt ? new Date(String(user.invitedAt)).toLocaleDateString() : "—"}
                    </td>
                    <td className="px-6 py-4 text-right">
                      <div className="flex items-center justify-end gap-1">
                        <ResendInvitationDialog
                          email={user.email}
                          onConfirm={() => onResend(user)}
                        />
                        <DeleteInvitationDialog
                          email={user.email}
                          onConfirm={() => onDelete(user.id)}
                        />
                      </div>
                    </td>
                  </tr>
                ))}
                {invitedUsers.length === 0 && !loading && (
                  <tr>
                    <td colSpan={4} className="px-6 py-8 text-center text-sm text-primary-600 dark:text-primary-400">
                      Nenhum convite pendente
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </TooltipProvider>
  );
}
